// extracted by mini-css-extract-plugin
export var accordion = "RegisteredFAQ-module--accordion--e1495";
export var accordionContent = "RegisteredFAQ-module--accordionContent--d62ea";
export var custom = "RegisteredFAQ-module--custom--99ef3";